export const CAPTAIN_WORKING_SUMMARIES_LIST = "SUPPLIERS_PORTAL_CAPTAIN_WORKING_SUMMARIES_LIST";
export const CAPTAIN_WORKING_SUMMARIES_SHOW = "SUPPLIERS_PORTAL_CAPTAIN_WORKING_SUMMARIES_SHOW";